import IconButton from 'components/Luxkit/Button/IconButton'
import SolidTimesIcon from 'components/Luxkit/Icons/solid/SolidTimesIcon'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import zIndex from 'styles/tools/z-index'

const _AboveCardCloseButton = styled(IconButton)`
  position: absolute;
  bottom: calc(100% + ${rem(16)});
  right: 0;
  z-index: ${zIndex.menu};
  box-shadow: ${(props) => props.theme.shadow.flat.large};
  border-color: ${(props) => props.theme.palette.neutral.default.eight};
  background-color: ${(props) => props.theme.palette.neutral.default.eight};
`

export default function AboveCardCloseButton({ onClick }: Pick<React.ComponentProps<typeof _AboveCardCloseButton>, 'onClick'>) {
  return (
    <_AboveCardCloseButton
      kind="primary"
      variant="ghost"
      size="medium"
      shape="circle"
      aria-label="Close"
      onClick={onClick}
    >
      <SolidTimesIcon />
    </_AboveCardCloseButton>
  )
}
